export const GET_USER_PROFILE_SUCCESS = 'app/GET_USER_PROFILE_SUCCESS';
export const GET_USER_PROFILE_FAILED = 'app/GET_USER_PROFILE_FAILED';

export const UPDATE_USER_PROFILE_LOADING = 'app/UPDATE_USER_PROFILE_LOADING';
export const UPDATE_USER_PROFILE_SUCCESS = 'app/UPDATE_USER_PROFILE_SUCCESS';
export const UPDATE_USER_PROFILE_FAILED = 'app/UPDATE_USER_PROFILE_FAILED';

export const DELETE_USER_PROFILE_SUCCESS = 'app/DELETE_USER_PROFILE_SUCCESS';
export const DELETE_USER_PROFILE_FAILED = 'app/DELETE_USER_PROFILE_FAILED';
